var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"flex items-center gap-1 text-brand-dark hover:text-brand-red transition-colors py-6",attrs:{"href":"#"},on:{"mouseenter":function($event){return _vm.$emit('hover')},"focus":function($event){return _vm.$emit('hover')}}},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('ChevronDownIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }